function updateShippingBar() {
  const FREE_SHIPPING_THRESHOLD = 9800;
  const MAX_THRESHOLD = 10500;

  const shippingBar = document.getElementById('ur-free-shipping-bar');
  if (!shippingBar) return;

  const messageElement = document.getElementById('ur-shipping-message');
  const progressFill = document.getElementById('ur-progress-fill');
  const markerShipping = document.getElementById('marker-shipping');
  const labelShipping = document.getElementById('label-shipping');

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const currentTotal = cart.total_price / 100;

      let message = '';
      let progress = 0;
      let progressColor = '';

      if (currentTotal >= FREE_SHIPPING_THRESHOLD) {
        message = '送料無料でお届けいたします。';
        progress = 100;
        progressColor = 'linear-gradient(90deg, #ff9a9e, #fad0c4)';
        markerShipping.style.backgroundImage = 'url(https://cottonhugg.jp/cdn/shop/files/free-1.png)';
      } else {
        const remainingShipping = FREE_SHIPPING_THRESHOLD - currentTotal;
        message = `あと¥${remainingShipping.toLocaleString()}で送料無料`;
        progress = (currentTotal / MAX_THRESHOLD) * 100;
        progressColor = 'linear-gradient(270deg, rgba(244, 236, 217, 1), rgba(183, 212, 218, 1) 100%)';
        markerShipping.style.backgroundImage = 'url(https://cottonhugg.jp/cdn/shop/files/free-2.png)';
      }

      messageElement.textContent = message;
      progressFill.style.width = `${Math.min(progress, 100)}%`;
      progressFill.style.background = progressColor;

      const shippingPos = (FREE_SHIPPING_THRESHOLD / MAX_THRESHOLD) * 100;
      markerShipping.style.left = `${shippingPos}%`;
      labelShipping.textContent = `¥${FREE_SHIPPING_THRESHOLD.toLocaleString()}`;
      labelShipping.style.left = `${shippingPos}%`;

      shippingBar.classList.add('is-visible'); // 表示状態にする
    })
    .catch(() => {
      shippingBar.classList.remove('is-visible');
    });
}

function initializeShippingBar() {
  updateShippingBar();

  // jQuery ajaxComplete
  if (window.jQuery) {
    $(document).ajaxComplete((event, xhr, settings) => {
      if (settings && settings.url &&
        (settings.url.includes('/cart/change.js') || settings.url.includes('/cart/update.js'))) {
        console.log('Cart update AJAX detected');
        setTimeout(updateShippingBar, 300);
      }
    });
  }

  // Canopyテーマのイベント
  window.addEventListener('cc-cart-updated', () => {
    console.log('cc-cart-updated event fired');
    updateShippingBar();
  });

  // MutationObserverでDOM変化も検知
  const observer = new MutationObserver(() => {
    // console.log('MutationObserver detected DOM change');
    setTimeout(updateShippingBar, 300);
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

window.addEventListener('load', initializeShippingBar);
